import {
  BodyLG,
  BodyLGB,
  BodyMD,
  BodyXL,
  Heading2XL,
  Heading3XL,
  Heading4XL,
  HeadingLG,
  HeadingXL,
} from "../../../typography";

import { Link } from "react-router-dom";
import { RiveAnimation } from "../../components/ui/RiveAnimation";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";
import { StatsSection } from "../../components/sections/StatsSection";

export const Hero = () => (
  <div className="tw-relative tw-flex tw-items-center tw-gap-y-[2em]">
    <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-x-[1em] tw-gap-y-[2.625em] min440:tw-flex-row min440:tw-px-[1.5em]">
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-y-[1.5em] tw-text-center min440:tw-w-1/2 min440:tw-items-start min440:tw-text-left">
        <Heading2XL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
          For Providers
        </Heading2XL>
        <div>
          <Heading4XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min440:tw-flex">
            Verse replaces
          </Heading4XL>
          <Heading4XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min440:tw-flex">
            phone calls, texts & faxes with software
          </Heading4XL>
        </div>
        <Heading3XL className="tw-my-0 tw-text-white min440:tw-hidden">
          Verse replaces phone calls, texts & faxes with software
        </Heading3XL>
        <div className="tw-flex tw-w-full tw-flex-col tw-gap-y-[.5em] min440:tw-gap-y-[1em]">
          <HeadingXL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
            Clarity & transparency for each order
          </HeadingXL>
          <HeadingLG className="tw-my-0 tw-text-white min440:tw-hidden">
            Clarity & transparency for each order
          </HeadingLG>
          <BodyXL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
            DME ordering is tied up with phone calls, faxes and texts. Verse
            replaces these with software that provides clarity & transparency
            for every order.
          </BodyXL>
          <BodyLG className="tw-my-0 tw-text-white min440:tw-hidden">
            DME ordering is tied up with phone calls, faxes and texts. Verse
            replaces these with software that provides clarity & transparency
            for every order.
          </BodyLG>
        </div>
        <Link to="/contact">
          <StandardButton
            style="primary-blue"
            onClick={() => {}}
            className="tw-z-40 tw-rounded-full tw-p-[1em] tw-px-[4em] tw-text-[16px]"
          >
            <BodyLGB className="tw-mb-0 tw-hidden tw-text-white min440:tw-flex">
              Get a demo
            </BodyLGB>
            <BodyMD className="tw-mb-0 tw-text-white min440:tw-hidden">
              Get a demo
            </BodyMD>
          </StandardButton>
        </Link>
        <StatsSection
          className="tw-mt-[1.5em] min440:tw-mt-[2.5em] min440:tw-grid-cols-3"
          stats={[
            { value: ">95%", description: "orders delivered on time" },
            { value: ">85%", description: "of orders don't need follow-up" },
            { value: "15-20", description: "minutes saved per DME order" },
            { value: "81", description: "provider NPS" },
            { value: "4.8/5", description: "member satisfaction" },
          ]}
        />
      </div>
      <div className="min440:tw-w-1/2">
        <RiveAnimation
          fallbackSrc="/landing_page_assets/providers_page/globe.png"
          fallbackClassName="tw-h-full tw-w-full"
        />
      </div>
    </div>
  </div>
);
